import { Controller } from "@hotwired/stimulus";
import Dropzone from "dropzone";

export default class extends Controller {
static values = {
    webId: String,
    identifier: String,
    url: String,
    message: String
  }
  connect() {
    const isDisabled = this.element.classList.contains('disabled');

    const webIdValue = this.webIdValue;
    const identifierValue = this.identifierValue;
    const url = this.urlValue;

    const overlay = document.getElementById('overlay-'+ this.identifierValue); // Get the overlay element
    Dropzone.autoDiscover = false;
    const dropzoneConfig = {
      url: url,
      method: "post",
      clickable: !isDisabled,
      paramName: "file",
      maxFilesize: 20,
      parallelUploads: "5",
      disablePreviews: true,
      addRemoveLinks: !isDisabled,
      createImageThumbnails: false,
      maxFiles: 5,
      acceptedFiles: ".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.tif,.tiff",
      dictDefaultMessage: this.messageValue || 'Hier klicken um Dokument(e) auszuwählen oder Dokument(e) einfach hier ablegen.',
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      init: function() {
        this.on("sending", (file, xhr, formData) => {
          // Append additional parameters before the file is sent
          formData.append("web_id", webIdValue);
          formData.append("identifier", identifierValue);
          overlay.style.display = 'flex';
          overlay.innerHTML = '<div class="spinner"></div>';
        });

        this.on("success", (file) => {
          const errorMessageContainer = document.getElementById(`error-message-${identifierValue}`);
          errorMessageContainer.style.display = 'none';
          errorMessageContainer.textContent = '';
          const uploadStatusSymbol = document.getElementById('upload-status-' + identifierValue);
          if (uploadStatusSymbol) {
            uploadStatusSymbol.setAttribute('hasbeenuploaded', 'true');
          }
          const listItem = document.createElement('li');
          listItem.textContent = file.name; // Set the text content to the file's name
          document.getElementById('uploaded-files-' + identifierValue).appendChild(listItem);
        });

        this.on("queuecomplete", () => {
          overlay.style.display = 'none';
          overlay.innerHTML = ''; // Clear the spinner element
          this.removeAllFiles(true);
        });

        this.on("maxfilesexceeded", (file) => {
          this.removeFile(file);
          const errorMessageContainer = document.getElementById(`error-message-${identifierValue}`);
          errorMessageContainer.textContent = 'Maximal 5 Dateien auf einmal erlaubt.';
          errorMessageContainer.style.display = 'block'; // Make the error message visible
        });

        this.on("error", (file, response) => {
          if (response.redirect_to) {
            window.location.href = response.redirect_to;
            return;
          }
          let errorMessage;
          if (file.size > 20 * 1024 * 1024) {
            errorMessage = "Die Datei ist zu groß. Maximal 20 MB erlaubt.";
          } else if(file.accepted === false) {
            errorMessage = 'Die Datei muss eine der folgenden Erweiterungen haben: .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .tif, .tiff';
          } else {
            errorMessage = response.error || "Ein Fehler ist aufgetreten.";
          }
          this.removeFile(file)
          // Assuming the error message container has an id like "error-message-<identifier>"
          const errorMessageContainer = document.getElementById(`error-message-${identifierValue}`);
          errorMessageContainer.textContent = errorMessage;
          errorMessageContainer.style.display = 'block'; // Make the error message visible

          overlay.style.display = 'none'; // Hide the overlay
        });


      }
    };


    this.dropzone = new Dropzone(this.element, dropzoneConfig);

    if (isDisabled) {
      this.disableDropzoneInteractions();
    }
  }
  disableDropzoneInteractions() {
    // Optional: Implement additional logic to visually indicate disabled state
    this.element.querySelectorAll('input, button, select').forEach(el => el.disabled = true);
  }
}
